import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Collection Redux States
import {
  GET_COLLECTION_NAME_VERIFY,
  GET_COLLECTION_BYTECODE,
  GET_COLLECTIONS,
  POST_COLLECTION,
  GET_COLLECTION,
  GET_COLLECTION_BY_ADDRESS,
  PUT_COLLECTION,
  DELETE_COLLECTION,
  POST_NEW_COLLECTION,
  GET_COLLECTIONS2,
  GET_NEW_COLLECTIONS_BY_EMAIL_START,
  DELETE_NEW_COLLECTION_START,
  PUT_NEW_COLLECTION_BY_ID_START,
  GET_NEW_COLLECTION_BY_ID_START,
  GET_ALL_NEW_COLLECTION_WITH_FILTER_START,
} from "./actionTypes";
import {
  getCollectionNameVerifyFail,
  getCollectionNameVerifySuccess,
  getCollectionBytecodeFail,
  getCollectionBytecodeSuccess,
  getCollectionsFail,
  postCollectionFail,
  postCollectionSuccess,
  getCollectionFail,
  getCollectionSuccess,
  putCollectionFail,
  putCollectionSuccess,
  getCollections2Success,
  getCollectionsFail2,
  getNewCollectionByEmailFail,
  getNewCollectionByEmailSuccess,
  deleteNewCollectionFail,
  deleteNewCollectionSuccess,
  getNewCollectionByIdFail,
  getNewCollectionByIdSuccess,
  getAllNewCollectionsFail,
  getAllNewCollectionsSuccess,
  getAllNewCollectionsWithFilterFail,
  getAllNewCollectionsWithFilterSuccess,
} from "./actions";

import {
  getCollectionNameVerify,
  getCollectionBytecode,
  getCollections,
  postCollection,
  getCollection,
  getCollectionByAddress,
  putCollection,
  postNewCollectionApi,
  getCollection2,
  getNewCollectionByEmail,
  deleteNewCollectionapi,
  getCollectionByIdApi,
  getNewCollectionByIdApi,
  putNewCollectionByIdApi,
  getAllNewCollectionsApi,
  getAllNewCollectionsWithFilterApi,
} from "helpers/backend_helper";
import { GET_ALL_NEW_COLLECTIONS } from "helpers/url_helper";
import toastr from "toastr";

function* onGetCollectionNameVerify({ payload: { name, callback } }) {
  try {
    const response = yield call(getCollectionNameVerify, name);

    if (response.status === "failure") {
      return yield put(getCollectionNameVerifyFail(response.message));
    }

    callback && callback(response);

    yield put(getCollectionNameVerifySuccess(response));
  } catch (error) {
    yield put(getCollectionNameVerifyFail(error));
  }
}

function* onGetCollectionBytecode({ payload: { data, callback } }) {
  try {
    const response = yield call(getCollectionBytecode, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(getCollectionBytecodeFail(response.message));
    }

    yield put(getCollectionBytecodeSuccess(response));
  } catch (error) {
    yield put(getCollectionBytecodeFail(error));
  }
}

function* fetchCollections({ payload: { data, callback } }) {
  try {
    const response = yield call(getCollections, data);

    if (response.status === "failure") {
      return yield put(getCollectionsFail(response.message));
    }
    yield put(getCollections2Success(response));
    callback && callback(response);
  } catch (error) {
    yield put(getCollectionsFail2(error));
  }
}

function* onPostCollection({ payload: { collection, callback } }) {
  try {

    const response = yield call(postCollection, collection);
    if (response.status === "failure") {
      window.scrollTo(0, 0);

      return yield put(postCollectionFail(response.message));
    }

    callback && callback(response);

    yield put(postCollectionSuccess());
  } catch (error) {
    yield put(postCollectionFail("Internal Error!"));
  }
}

function* onPostNewCollection({ payload: { collection, callback } }) {
  try {

    const response = yield call(postNewCollectionApi, collection);
    if (response.status === "failure") {
       window.scrollTo(0, 0);
      
      return yield put(postCollectionFail(response.message));
    }

    callback && callback(response);

    yield put(postCollectionSuccess());
  } catch (error) {
    if (error?.response?.data?.status_code == 400){
      toastr.error(error?.response?.data?.message);
// console.log("Collection already exists for this user",error)
    }
    
    yield put(postCollectionFail("Internal Error!"));
  }
}

function* fetchCollection({ payload: { id, callback } }) {
  try {
    const response = yield call(getCollection, id);

    if (response.status === "failure") {
      return yield put(getCollectionFail(response.message));
    }
    callback && callback(response);

    yield put(getCollectionSuccess(response));
  } catch (error) {
    yield put(getCollectionFail(error));
  }
}

function* fetchCollectionByAddress({ payload: { address, callback } }) {
  try {
    const response = yield call(getCollectionByAddress, address);

    if (response.status === "failure") {
      return yield put(getCollectionFail(response.message));
    }

    callback && callback(response);

    yield put(getCollectionSuccess(response));
  } catch (error) {
    yield put(getCollectionFail(error));
  }
}

function* onGetCollection2() {
  try {
    const response = yield call(getCollection2);
    if (response.status === "failure") {
      return yield put(putCollectionFail(response.message));
    }
    yield put(getCollections2Success(response));
  } catch (error) {
    yield put(putCollectionFail("Internal Error!"));
  }
}



function* onPutCollection({ payload: { data, callback } }) {
  try {
    const response = yield call(putCollection, data);

    if (response.status === "failure") {
      return yield put(putCollectionFail(response.message));
    }

    callback && callback(response);

    yield put(putCollectionSuccess());
  } catch (error) {
    yield put(putCollectionFail("Internal Error!"));
  }
}


function* onGetNewCollectionByEmail({ payload: { data, callback } }) {
  try {
  //  let data = {}
  //    data.email= email
    const response = yield call(getNewCollectionByEmail, data);
    callback && callback(response);
    if (response.status === "failure") {
      return yield put(getNewCollectionByEmailFail(response.message));
    }
    yield put(getNewCollectionByEmailSuccess(response));
   
  } catch (error) {
    yield put(getNewCollectionByEmailFail("Internal Error!"));
  }
}


function* onDeleteNewCollectionByEmail({ payload: { collectionId, callback } }) {

  try {
   
    const response = yield call(deleteNewCollectionapi, collectionId);

    if (response.status === "failure") {
      return yield put(deleteNewCollectionFail(response.message));
    }
    callback && callback(response);
    yield put(deleteNewCollectionSuccess(response));
  } catch (error) {
    yield put(deleteNewCollectionFail("Internal Error!"));
  }
}
function* onUpdateNewCollectionById({ payload: { collection, callback } }) {
  try {
    const response = yield call(putNewCollectionByIdApi, collection);

    if (response.status === "failure") {
      return yield put(putCollectionFail(response.message));
    }

    callback && callback(response);

    yield put(putCollectionSuccess());
  } catch (error) {
    yield put(putCollectionFail("Internal Error!"));
  }
}

function* onGetNewCollectionById({ payload: { id, callback } }) {

  try {
    const response = yield call(getNewCollectionByIdApi,id);

    if (response.status === "failure") {
      return yield put(getNewCollectionByIdFail(response.message));
    }
    callback && callback(response);

    yield put(getNewCollectionByIdSuccess(response));
  } catch (error) {
    yield put(getNewCollectionByIdFail(error));
  }
}

function* onGetAlNewCollections({ payload: { id, callback } }) {
  try {
    const response = yield call(getAllNewCollectionsApi,id);

    if (response.status === "failure") {
      return yield put(getAllNewCollectionsFail(response.message));
    }
    callback && callback(response);

    yield put(getAllNewCollectionsSuccess(response));
  } catch (error) {
    yield put(getAllNewCollectionsFail(error));
  }
}

function* onGetAlNewCollectionsWithFilter({ payload: { data, callback } }) {
  try {
    const response = yield call(getAllNewCollectionsWithFilterApi,data);

    if (response.status === "failure") {
      return yield put(getAllNewCollectionsWithFilterFail(response.message));
    }
    callback && callback(response);

    yield put(getAllNewCollectionsWithFilterSuccess(response?.data));
  } catch (error) {
    yield put(getAllNewCollectionsWithFilterFail(error));
  }
}

function* CollectionsSaga() {
  yield takeEvery(GET_COLLECTION_NAME_VERIFY, onGetCollectionNameVerify);
  yield takeEvery(GET_COLLECTION_BYTECODE, onGetCollectionBytecode);
  yield takeLatest(GET_COLLECTIONS, fetchCollections);
  yield takeEvery(POST_COLLECTION, onPostCollection);
  yield takeEvery(POST_NEW_COLLECTION, onPostNewCollection);
  yield takeEvery(GET_COLLECTION, fetchCollection);
  yield takeEvery(GET_COLLECTION_BY_ADDRESS, fetchCollectionByAddress);
  yield takeEvery(PUT_COLLECTION, onPutCollection);

yield takeEvery(GET_COLLECTIONS2, onGetCollection2);
yield takeEvery(GET_NEW_COLLECTIONS_BY_EMAIL_START, onGetNewCollectionByEmail);
yield takeEvery(DELETE_NEW_COLLECTION_START, onDeleteNewCollectionByEmail);
yield takeLatest(PUT_NEW_COLLECTION_BY_ID_START, onUpdateNewCollectionById);
yield takeEvery(GET_NEW_COLLECTION_BY_ID_START, onGetNewCollectionById);
yield takeEvery(GET_ALL_NEW_COLLECTIONS, onGetAlNewCollections);
yield takeEvery(GET_ALL_NEW_COLLECTION_WITH_FILTER_START, onGetAlNewCollectionsWithFilter);
}

export default CollectionsSaga;